module.exports = __webpack_public_path__ + "img/calendar.79a8574e.svg";